<!-- partial:partials/_sidebar.html -->
<nav class="sidebar sidebar-offcanvas d-print-none" id="sidebar">
    <ul class="nav">
        <li class="nav-item">
            <a class="nav-link" routerLink="/home">
                <i class="icon-grid menu-icon"></i>
                <span class="menu-title">Dashboard</span>
            </a>
        </li>

        <!-- Requests -->
        <li class="nav-item" *ngIf="showRequestsMenu">
            <a class="nav-link" data-toggle="collapse" href="#ui-basic" aria-expanded="false" aria-controls="ui-basic">
                <i class="icon-file menu-icon"></i>
                <span class="menu-title">Contractor Requests</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="ui-basic">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" *ngIf="canAddRequest"> <a class="nav-link" routerLink="/createrequest">Create Request</a>
                    </li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/requests">View Requests</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/approvedrequests">My Approved Requests</a></li>
                    <li class="nav-item" *ngIf="canApproveRequest">
                        <a class="nav-link" routerLink="/approverequests">Approve Requests   <span class="badge">{{pendingRequestCount}}</span>
            
            </a>
                    </li>



                    <li class="nav-item" *ngIf="!canAddRequest && showRequestsMenu"> <a class="nav-link" routerLink="/expressapproval">Express Approval
              <span class="badge">{{pendingexpressApprovalsCount}}</span>
            </a>
                    </li>

                    <li class="nav-item" *ngIf="canApproveChange"> <a class="nav-link" routerLink="/pendingapprovals">Pending Approvals
            <span class="badge">{{changeEmpCount}}</span>
          </a>

          
                    </li>
                              <li class="nav-item"> <a class="nav-link" routerLink="/allrequests">All Requests</a></li>

                </ul>
            </div>
        </li>
        <li class="nav-item" *ngIf="showRequestsMenu">
            <a class="nav-link" data-toggle="collapse" href="#ui-basicA" aria-expanded="false" aria-controls="ui-basic">
                <i class="icon-file menu-icon"></i>
                <span class="menu-title">AdHoc Requests</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="ui-basicA">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" > <a class="nav-link" routerLink="/createadhocrequest">Create Request</a>
                    </li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/adhocrequests">View Requests</a></li>
                    <!-- <li class="nav-item"> <a class="nav-link" routerLink="/approvedrequests">My Approved Requests</a></li> -->
                    <!-- <li class="nav-item" *ngIf="canApproveRequest"> -->
                    <li class="nav-item" >
                        <a class="nav-link" routerLink="/approveadhocrequests">Approve Requests   <span class="badge">{{adhocApproverCount}}</span>
            
            </a>
                    </li>



                    <li class="nav-item" *ngIf="!canAddRequest && showRequestsMenu"> <a class="nav-link" routerLink="/expressapproval">Express Approval
              <span class="badge">{{pendingexpressApprovalsCount}}</span>
            </a>
                    </li>

                    <li class="nav-item" *ngIf="canApproveChange"> <a class="nav-link" routerLink="/pendingapprovals">Pending Approvals
            <span class="badge">{{changeEmpCount}}</span>
          </a>
                    </li>

                </ul>
            </div>
        </li>

        <!-- Recruitment Workflow -->
        <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#ui-basics" aria-expanded="false" aria-controls="ui-basic">
                <i class="icon-file menu-icon"></i>
                <span class="menu-title">Manpower Request</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="ui-basics">
                <ul class="nav flex-column sub-menu">
                    <!-- <li class="nav-item"> <a class="nav-link" routerLink="/manpower">Create Request</a>
                    </li> -->
                    <li class="nav-item"> <a class="nav-link" routerLink="/manpowerrequest">View Requests</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/approvedmanpowerrequests">My Approved Request</a></li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/approvemanpowerrequests">Approve Requests <span class="badge">{{manPowerpendingRequestCount}}</span>
                  
                  </a>
                    </li>




                </ul>
            </div>
        </li>

        <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#recruitments" aria-expanded="false" aria-controls="ui-basic">
                <i class="icon-file menu-icon"></i>
                <span class="menu-title">Recruitment Workflow</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="recruitments">
                <ul class="nav flex-column sub-menu">
                    
                    <li class="nav-item"> <a class="nav-link" routerLink="/newhire">Onboard New Hire</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/new-hires-view">External Hires </a></li>

                </ul>
            </div>
        </li>

        <!-- Movement Request Form -->

        <li class="nav-item">
            <a class="nav-link" data-toggle="collapse" href="#uii-basics" aria-expanded="false" aria-controls="ui-basic">
                <i class="icon-file menu-icon"></i>
                <span class="menu-title">Movement Request</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="uii-basics">
                <ul class="nav flex-column sub-menu">
                    <!-- <li class="nav-item"> <a class="nav-link" routerLink="/movement">Create Request</a>
                    </li> -->
                    <li class="nav-item"> <a class="nav-link" routerLink="/movementrequest">View Requests</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/approvedmovementrequests">My Approved Requests</a></li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/approvemovementrequests">Approve Requests <span class="badge">{{movementpendingRequestCount}}</span>
                    
                    </a>
                    </li>




                </ul>
            </div>
        </li>

        <!-- Job Rotation Menu -->
       <li class="nav-item" >
            <a class="nav-link" data-toggle="collapse" href="#job-rotation" aria-expanded="false" aria-controls="ui-basic">
                <i class="icon-file menu-icon"></i>
                <span class="menu-title">Job Rotation</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="job-rotation">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" > <a class="nav-link" routerLink="/createjobrotationrequest">Create Request</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/viewjobrotations">View Requests</a></li>
                     
                    <li class="nav-item" >
                        <a class="nav-link" routerLink="/approvejobrotation">Approve Requests   <span class="badge">{{pendingJobRotationApprovalsCount}}</span></a>
                    </li>
                    

                </ul>
            </div>
        </li>


 <!-- Exit Clearance Request Form -->

 <li class="nav-item">
    <a class="nav-link" data-toggle="collapse" href="#uiio-basics" aria-expanded="false" aria-controls="ui-basic">
        <i class="icon-file menu-icon"></i>
        <span class="menu-title">Exit Clearance</span>
        <i class="menu-arrow"></i>
    </a>
    <div class="collapse" id="uiio-basics">
        <ul class="nav flex-column sub-menu">
            <li class="nav-item" *ngIf="isHRBP"> <a class="nav-link" routerLink="/exitclearance">Initiate Exit Clearance</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" routerLink="/approveexitclearance">Pending Approvals <span class="badge">{{exitClearanceApproverCount}}</span>
            
            </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" routerLink="/authorizeclearance">Pending Authorization <span class="badge">{{authorizePendingCount}}</span>
            
            </a>
            </li>
            
            <li class="nav-item"> <a class="nav-link" routerLink="/exitclearanceforms">Exit Clearance Forms</a></li>
            <li class="nav-item" *ngIf="isHRBP"> <a class="nav-link" routerLink="/exitclearanceUserManagement">Approval Management</a></li>
            <li class="nav-item" *ngIf="isHRBP"> <a class="nav-link" routerLink="/exitclearancereport">All Clearance Forms</a></li>
      
            </ul>
    </div>
</li>


        <!-- Employees -->
        <li class="nav-item" *ngIf="showEmployeesMenu">
            <a class="nav-link" data-toggle="collapse" href="#form-elements" aria-expanded="false" aria-controls="form-elements">
                <i class="icon-head menu-icon"></i>
                <span class="menu-title">Employees</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="form-elements">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" *ngIf="canAddEmployee"> <a class="nav-link" routerLink="/createemployee">Upload
              Employee</a></li>
                    <li class="nav-item" *ngIf="canVerifyEmployee"> <a class="nav-link" routerLink="/verifyemployees">Verify
              Employees</a></li>
                    <li class="nav-item" *ngIf="canVerifyEmployee"> <a class="nav-link" routerLink="/employees">View Employees</a></li>
                </ul>
            </div>
        </li>

        <!-- Skills -->
        <li class="nav-item" *ngIf="showSkillsMenu">
            <a class="nav-link" data-toggle="collapse" href="#charts" aria-expanded="false" aria-controls="charts">
                <i class="icon-bar-graph menu-icon"></i>
                <span class="menu-title">Skills</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="charts">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" *ngIf="canAddSkill"> <a class="nav-link" routerLink="/createskill">Create Skill</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/skills">View Skills</a></li>
                </ul>
            </div>
        </li>



        <!-- Contractors -->
        <li class="nav-item" *ngIf="showContractorsMenu">
            <a class="nav-link" data-toggle="collapse" href="#tables" aria-expanded="false" aria-controls="tables">
                <i class="icon-columns menu-icon"></i>
                <span class="menu-title">Contractors</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="tables">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" *ngIf="canAddContractor"> <a class="nav-link" routerLink="/createvendor">Create
              Contractor</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/vendors">View Contractors</a></li>
                </ul>
            </div>
        </li>

        <!-- cost center  -->
        <li class="nav-item" *ngIf="showCostCentersMenu">
            <a class="nav-link" data-toggle="collapse" href="#costcenter" aria-expanded="false" aria-controls="costcenter">
                <i class="icon-contract menu-icon"></i>
                <span class="menu-title">Cost Center</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="costcenter">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" *ngIf="canAddCostCenter"> <a class="nav-link" routerLink="/createcostcenter">Create Cost
              Center</a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/costcenters">View Cost Centers</a></li>
                </ul>
            </div>
        </li>

        <!-- location -->
        <li class="nav-item" *ngIf="showLocationsMenu">
            <a class="nav-link" data-toggle="collapse" href="#location" aria-expanded="false" aria-controls="location">
                <i class="icon-globe menu-icon"></i>
                <span class="menu-title">Location</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="location">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" *ngIf="canAddLocation"> <a class="nav-link" routerLink="/createlocation"> Create Location
            </a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/locations"> View Locations </a></li>
                </ul>
            </div>
        </li>

        <!-- Axiom -->
        <li class="nav-item" *ngIf="showLocationsMenu">
            <a class="nav-link" data-toggle="collapse" href="#axiom" aria-expanded="false" aria-controls="axiom">
                <i class="icon-globe menu-icon"></i>
                <span class="menu-title">Axiom</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="axiom">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" *ngIf="canAddLocation || isHRBP"> <a class="nav-link" routerLink="/createaxiom"> Create Axiom
            </a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/axioms"> View Axioms </a></li>
                </ul>
            </div>
        </li>

        <!-- Designation -->
        <li class="nav-item" *ngIf="showDesignationsMenu">
            <a class="nav-link" data-toggle="collapse" href="#designation" aria-expanded="false" aria-controls="designation">
                <i class="icon-grid-2 menu-icon"></i>
                <span class="menu-title">Designation</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="designation">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" *ngIf="canAddDesignation"> <a class="nav-link" routerLink="/createdesignation"> Create
              Designation </a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/designations"> View Designations </a></li>
                </ul>
            </div>
        </li>
        <!-- approval levels -->
        <li class="nav-item" *ngIf="showUsersMenu">
            <a class="nav-link" data-toggle="collapse" href="#approvals" aria-expanded="false" aria-controls="charts">
                <i class="icon-bar-graph menu-icon"></i>
                <span class="menu-title">Approval Levels</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="approvals">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item"> <a class="nav-link" routerLink="/approvallevels">Approval Levels</a></li>
                </ul>
            </div>
        </li>
        <!-- Roles and Permission -->
        <li class="nav-item" *ngIf="showRolesAndPermissionsMenu">
            <a class="nav-link" data-toggle="collapse" href="#roles" aria-expanded="false" aria-controls="roles">
                <i class="icon-tag menu-icon"></i>
                <span class="menu-title">Roles & Permissions</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="roles">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item"> <a class="nav-link" routerLink="/viewroles"> View Roles</a></li>
                    <li class="nav-item" *ngIf="canAddRolesAndPermission"> <a class="nav-link" routerLink="/createrole"> Create
              Role</a></li>
                    <li class="nav-item" *ngIf="canUpdateRolesAndPermission"> <a class="nav-link" routerLink="/managerolepermissions"> Edit Permission </a></li>
                </ul>
            </div>
        </li>






        <!-- Biometric Induction -->
        <li class="nav-item" *ngIf="showInductionMenu">
            <a class="nav-link" data-toggle="collapse" href="#induction" aria-expanded="false" aria-controls="roles">
                <i class="icon-tag menu-icon"></i>
                <span class="menu-title">Biometric Info</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="induction">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item"> <a class="nav-link" routerLink="/employeeinduction"> View Employees</a></li>

                </ul>
            </div>
        </li>

        <!-- Safety Induction -->
        <li class="nav-item" *ngIf="showSafetyInductionMenu">
            <a class="nav-link" data-toggle="collapse" href="#safety" aria-expanded="false" aria-controls="roles">
                <i class="icon-tag menu-icon"></i>
                <span class="menu-title">Safety Info</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="safety">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item"> <a class="nav-link" routerLink="/biometricinduction"> View Employees</a></li>

                </ul>
            </div>
        </li>

        <li class="nav-item" *ngIf="showUsersMenu">
            <a class="nav-link" data-toggle="collapse" href="#user" aria-expanded="false" aria-controls="user">
                <i class="icon-grid-2 menu-icon"></i>
                <span class="menu-title">Users</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="user">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" *ngIf="canAddUsers"> <a class="nav-link" routerLink="/createuser"> Create user </a></li>
                    <li class="nav-item"> <a class="nav-link" routerLink="/users"> View Users </a></li>
                </ul>
            </div>
        </li>

        <!-- Induction  -->
        <!-- <li class="nav-item">
      <a class="nav-link" data-toggle="collapse" href="#induction" aria-expanded="false" aria-controls="induction">
        <i class="icon-grid-2 menu-icon"></i>
        <span class="menu-title">Induction</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="collapse" id="induction">
        <ul class="nav flex-column sub-menu">
          <li class="nav-item" > <a class="nav-link" routerLink="/biometic"> Biometric Capture </a></li>
          <li class="nav-item"> <a class="nav-link" routerLink="/safetyinduction"> Safety Induction </a></li>
        </ul>
      </div>
    </li>  -->

        <li class="nav-item" *ngIf="showReportsMenu">
            <a class="nav-link" data-toggle="collapse" href="#report" aria-expanded="false" aria-controls="user">
                <i class="icon-grid-2 menu-icon"></i>
                <span class="menu-title">Reports</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="collapse" id="report">

                <nz-input-group [nzSuffix]="suffixIcon">
                    <input type="text" nz-input placeholder="Search" [(ngModel)]="searchValue" />
                </nz-input-group>
                <ng-template #suffixIcon>
                    <i nz-icon nzType="search"></i>
                </ng-template>
                <nz-tree [nzData]="nodes" [nzSearchValue]="searchValue" (nzClick)="nzEvent($event)" (nzExpandChange)="nzEvent($event)" (nzSearchValueChange)="nzEvent($event)"></nz-tree>

            </div>
        </li>
    </ul>
</nav>




<!-- partial -->